import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';

type Option = {
  value: string;
  color: string;
};

export type PerformersCheckboxProps = {
  option: Option;
  onChange: CheckboxProps['onChange'];
  label: string;
};

export const PerformersCheckbox = (props: PerformersCheckboxProps) => {
  const { option, label } = props;
  return (
    <FormControlLabel
      data-testid="performers-checkbox"
      key={option.value}
      control={
        <Checkbox
          defaultChecked
          onChange={props.onChange}
          sx={{
            color: option.color,
            '&.Mui-checked': {
              color: option.color,
            },
          }}
        />
      }
      label={label}
    />
  );
};
